/**
 * Formatos de presentación genéricos (sin dominio). Todo lo que llega de la API
 * como texto ISO se corta a mano, sin `new Date()`: un 'AAAA-MM-DD' interpretado
 * como UTC se corre un día en Bolivia (UTC−4).
 */

/** '2026-10-15' -> '15/10/2026'; '—' si no hay fecha. */
export function formatearFecha(iso) {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : '—';
}

/** '2026-09-29T16:52:40-04:00' -> '29/09/2026 16:52'; '—' si no hay. */
export function formatearFechaHora(iso) {
  const partes = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(iso || '');
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]} ${partes[4]}:${partes[5]}` : '—';
}

/**
 * Número con coma decimal y sin ceros de relleno: 1.5 -> '1,5', 2 -> '2',
 * 0.3333 -> '0,3333'. '—' si no es un número.
 */
export function formatearDecimal(valor, maxDecimales = 4) {
  const numero = Number(valor);
  if (valor === null || valor === undefined || valor === '' || !Number.isFinite(numero)) return '—';
  return String(Number(numero.toFixed(maxDecimales))).replace('.', ',');
}

/**
 * Lo que escribe el usuario ('1,5', ' 2 ') al formato que espera la API
 * ('1.5'). No valida: eso lo hace quien lo usa, con sus propios límites.
 */
export function textoConPuntoDecimal(texto) {
  return String(texto ?? '').trim().replace(',', '.');
}

/** "planes" o "plan" según la cantidad. */
export function plural(cantidad, singular, pluralTexto) {
  return Number(cantidad) === 1 ? singular : pluralTexto || `${singular}s`;
}

/** Hoy en 'AAAA-MM-DD', según el reloj de este equipo. */
export function hoyIso() {
  const hoy = new Date();
  const mes = String(hoy.getMonth() + 1).padStart(2, '0');
  const dia = String(hoy.getDate()).padStart(2, '0');
  return `${hoy.getFullYear()}-${mes}-${dia}`;
}
